<div class="brands-list box-container" #container>
    @if (brands()?.length) {
        <ul class="brands-list__list">
            @for (brand of brands(); track brand.id) {
                <li class="brands-list__list-item">
                    <button type="button" class="link brands-list__item" (click)="onBrandClick(brand)">
                        {{ brand.name }}
                    </button>
                </li>
            }
        </ul>
    } @else {
        <ngx-skeleton-loader animation="progress-dark" [count]="8" [theme]="skeletonConfig" />
    }
</div>
